// extracted by mini-css-extract-plugin
export default {"show-background":"ShowPage_show-background__HF-rO"};